import React, { Component } from "react";
import "../../styles/ToolBarBottom.css";
import "../../styles/Converter.css";
import { currentLocals } from "../../languages/languages.js";

const REACT_APP_FETCH_CONFIG =
  window.process !== undefined ? window.process.env.REACT_APP_FETCH_CONFIG : process.env.REACT_APP_FETCH_CONFIG;
export default class ToolBarBottom extends Component {
  constructor(props) {
    super(props);

    this.handleClickDone = this.handleClickDone.bind(this);
    this.handleClickCancel = this.handleClickCancel.bind(this);
    this.defineGeneralStatus = this.defineGeneralStatus.bind(this);
  }
  handleClickDone(event) {
    const { donePatternConverter } = this.props;

    // Buscamos los objetos a descargar

    let txt = "DownLoad_";
    let length = txt.length;
    let TodosFicheros = "";

    var x = document.getElementsByClassName("download");
    var i;
    for (i = 0; i < x.length; i++) {
      if (x[i].style.visibility === "visible") {
        let idDL = x[i].id;
        let id = idDL.substring(length);

        if (TodosFicheros !== "") TodosFicheros = TodosFicheros + ",";
        TodosFicheros = TodosFicheros + id;
      }
    }

    donePatternConverter(TodosFicheros);
    /*
    if (i > 0) donePatternConverter(TodosFicheros);
    else cancelPatternConverter();
    */
  }
  handleClickCancel(event) {
    //alert("Cancel");
    const { cancelPatternConverter } = this.props;
    cancelPatternConverter();
  }

  defineGeneralStatus() {
    const { conversions } = this.props;
    let PendingToFinish = false;
    for (let i = 0; i < conversions.length; i++) {
      let conversion = conversions[i];
      if (conversion.status === "Sent" || conversion.status === "in_convertion") {
        PendingToFinish = true;
      }
    }

    return PendingToFinish;
  }

  render() {
    const Connected = "Yes";
    let display = Connected === "Yes" ? "block" : "none";
    const { locale } = this.props;
    let currenlocale = locale;
    let PendingToFinish = "disabled";
    PendingToFinish = this.defineGeneralStatus();

    if (PendingToFinish) {
      return (
        <div id="ToolbarBottom" className="ToolbarBottom" style={{ textAlign: "left", display: display }}>
          <button className={`ToolbarBottomButton disabled`} disabled onClick={(event) => this.handleClickDone(event)}>
            {currentLocals(currenlocale).general.Finish}
          </button>
          <button className="ToolbarBottomButton" onClick={(event) => this.handleClickCancel(event)}>
            {currentLocals(currenlocale).general.Cancel}
          </button>
        </div>
      );
    } else {
      return (
        <div id="ToolbarBottom" className="ToolbarBottom" style={{ textAlign: "left", display: display }}>
          <button className="ToolbarBottomButton " onClick={(event) => this.handleClickDone(event)}>
            {currentLocals(currenlocale).general.Finish}
          </button>
          {/*
      <button className={`ToolbarBottomButton ${PendingToFinish}`} onClick={(event) => this.handleClickDone(event)}>
        {currentLocals(currenlocale).general.Finish}
      </button>*/}
          <button className="ToolbarBottomButton" onClick={(event) => this.handleClickCancel(event)}>
            {currentLocals(currenlocale).general.Cancel}
          </button>
        </div>
      );
    }
  }
}
